 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-01e45cb6":"6787cd1e","chunk-0381785d":"754b901f","chunk-05a83194":"29998b6b","chunk-42e92090":"b831ea8e","chunk-2d222213":"2549b039","chunk-161e6008":"e3e2b307","chunk-1ac00730":"4550919c","chunk-1bd5e0ab":"681e3143","chunk-2ca61924":"835fefa0","chunk-2d0a4885":"5c00a674","chunk-2d0aa630":"7d2cc281","chunk-2d0abc10":"d757786d","chunk-2d0ac931":"cc71baa3","chunk-2d0b342b":"17f9f547","chunk-2d0b6918":"444e6dff","chunk-182b3949":"7e6f4085","chunk-07a4d962":"36250b61","chunk-4b1ac566":"99c04f8c","chunk-2d0b8b30":"5da32a40","chunk-2d0c211b":"56bba833","chunk-2d0c7b42":"82397f5c","chunk-2d0c8871":"190339e6","chunk-2d0cf315":"c8f5219d","chunk-2d0d0254":"6754db65","chunk-2d0d3342":"23d3e6af","chunk-2d0d3c84":"8ae4ece4","chunk-2d0d6d65":"64418c4d","chunk-2d0e2170":"5cf09853","chunk-2d0e9381":"581b25ba","chunk-2d0f0050":"43ca0cc8","chunk-2d2080c7":"7c774b9c","chunk-2d208e4e":"b047ec48","chunk-2d210953":"58be7dd2","chunk-2d212be3":"a44d5113","chunk-2d216786":"1a699859","chunk-2d217def":"9b86ebe8","chunk-2d21a9aa":"bdd6764c","chunk-2d21d677":"fea28098","chunk-2d21dba6":"806b9b17","chunk-2d21e024":"e620cac7","chunk-2d221bb5":"07296653","chunk-2d222064":"af9a1ad0","chunk-2d222cca":"4226e9f6","chunk-2d22895d":"4ebcf334","chunk-2d230313":"588f6a7e","chunk-2d230c96":"7d2ad78c","chunk-2d23721e":"7970ea5d","chunk-2d238653":"45da1810","chunk-3bfb9180":"13a1c399","chunk-3de106df":"c0a1687b","chunk-690f86fe":"7b60278c","chunk-6b07209d":"144c4416","chunk-7afcfde5":"2a500cbc","chunk-9ff0db28":"158a89d7","chunk-a01cea54":"6857e683","chunk-a01de000":"349821aa","chunk-a92718dc":"adcf7383","chunk-ba697648":"9b3f1c42","chunk-c1f5b748":"5410b143","chunk-dde0b5fe":"96cd8c40","chunk-e15c52f0":"520b3c07","chunk-e87df000":"1c7b15df","chunk-f3031366":"f637f9ee","chunk-f7af154a":"4316b5c1","stencil-polyfills-css-shim":"b85f8bdc","stencil-polyfills-dom":"6e9caa76","chunk-2d21da93":"d51ded21"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01e45cb6":1,"chunk-0381785d":1,"chunk-05a83194":1,"chunk-42e92090":1,"chunk-161e6008":1,"chunk-1ac00730":1,"chunk-1bd5e0ab":1,"chunk-2ca61924":1,"chunk-182b3949":1,"chunk-4b1ac566":1,"chunk-3bfb9180":1,"chunk-3de106df":1,"chunk-690f86fe":1,"chunk-6b07209d":1,"chunk-7afcfde5":1,"chunk-a92718dc":1,"chunk-ba697648":1,"chunk-c1f5b748":1,"chunk-dde0b5fe":1,"chunk-e15c52f0":1,"chunk-e87df000":1,"chunk-f3031366":1,"chunk-f7af154a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-01e45cb6":"8aea46ef","chunk-0381785d":"81c5b97d","chunk-05a83194":"e101cc26","chunk-42e92090":"2c88258d","chunk-2d222213":"31d6cfe0","chunk-161e6008":"773f85cb","chunk-1ac00730":"1395c3cc","chunk-1bd5e0ab":"112098c6","chunk-2ca61924":"d829cb7d","chunk-2d0a4885":"31d6cfe0","chunk-2d0aa630":"31d6cfe0","chunk-2d0abc10":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0b342b":"31d6cfe0","chunk-2d0b6918":"31d6cfe0","chunk-182b3949":"1d20f804","chunk-07a4d962":"31d6cfe0","chunk-4b1ac566":"c9a1a954","chunk-2d0b8b30":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0c7b42":"31d6cfe0","chunk-2d0c8871":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0d0254":"31d6cfe0","chunk-2d0d3342":"31d6cfe0","chunk-2d0d3c84":"31d6cfe0","chunk-2d0d6d65":"31d6cfe0","chunk-2d0e2170":"31d6cfe0","chunk-2d0e9381":"31d6cfe0","chunk-2d0f0050":"31d6cfe0","chunk-2d2080c7":"31d6cfe0","chunk-2d208e4e":"31d6cfe0","chunk-2d210953":"31d6cfe0","chunk-2d212be3":"31d6cfe0","chunk-2d216786":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d21d677":"31d6cfe0","chunk-2d21dba6":"31d6cfe0","chunk-2d21e024":"31d6cfe0","chunk-2d221bb5":"31d6cfe0","chunk-2d222064":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d230313":"31d6cfe0","chunk-2d230c96":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-2d238653":"31d6cfe0","chunk-3bfb9180":"ae059b01","chunk-3de106df":"1395c3cc","chunk-690f86fe":"ebd0de5f","chunk-6b07209d":"1395c3cc","chunk-7afcfde5":"0ec331c5","chunk-9ff0db28":"31d6cfe0","chunk-a01cea54":"31d6cfe0","chunk-a01de000":"31d6cfe0","chunk-a92718dc":"b3aef38a","chunk-ba697648":"3a14cb55","chunk-c1f5b748":"ec3c8e96","chunk-dde0b5fe":"fc8f4282","chunk-e15c52f0":"c02a0b0d","chunk-e87df000":"1d05e479","chunk-f3031366":"ff0f4ed1","chunk-f7af154a":"3dd7ed47","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-2d21da93":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
